export default __webpack_public_path__ + "static/media/Chris_Cn.6e232f04.webp";